.body{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header {
    font-size: 1.5em;
    margin-right: 20px;
    font-weight: bold;
}
